const func = ($target) => {
	var $tooltip = $target.find('[data-toggle="tooltip"]'),
		$basketQty = $target.find("[data-qty]"),
		$closeHeader = $target.find('.opened'),
		$openHeader = $target.find('.closed'),
		$mainCategory = $target.find('.main-category'),
		$subCategory = $target.find('.dropdown-menu');

	// open-close nav submenu
	$mainCategory.on('click',function () {
		$subCategory.not($(this).next('.dropdown-menu')).removeClass('show-submenu')
		$(this).next('.dropdown-menu').toggleClass('show-submenu')
	})
	$closeHeader.click(function (){
		$subCategory.removeClass('show-submenu')
		$('body').removeClass('overflow-hidden')
	})
	$openHeader.click(function () {
		$('body').addClass('overflow-hidden')
	})

	$.ajax({
		url: "/api/ecom/header",
		dataType: "json",
	}).done(function (data) {
		console.log(data);
		// update basket qty
		var $qty = $target.find('[data-id="qty"]');
		$qty.attr("class", "").text(data.cart.qty);
		if (data.cart.qty == 1) {
			$qty.addClass("singular");
		} else {
			$qty.addClass("plural");
		}
		$basketQty.attr("data-qty", data.cart.qty);
		if (data.cart.qty > 9) {
			$basketQty.addClass("double-digits");
		}

		// update account tooltip
		$tooltip.attr(
			"title",
			data.user.loggedIn ? "My Account" : "Sign in / Register"
		);
		$tooltip.attr(
			"data-original-title",
			data.user.loggedIn ? "My Account" : "Sign in / Register"
		);
		// update currency
		$('[data-id="currency"]').text(
			data.cart.currency.symbol + data.cart.currency.iso
		);
	});
};

export default func;
